// Import the functions you need from the SDKs you need
import {initializeApp} from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
  OAuthProvider,
  connectAuthEmulator,
} from 'firebase/auth';
import {getRemoteConfig} from 'firebase/remote-config';
// import {getAnalytics, isSupported} from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.GATSBY_FIREBASE_API_KEY,
  authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.GATSBY_FIREBASE_DATABASE_URL,
  projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
  storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.GATSBY_FIREBASE_APP_ID,
  measurementId: process.env.GATSBY_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase - Compatible avec Gatsby SSR
// Basé sur l'implémentation de la PR #1
let app: any = null;
let auth: any = null;
let remoteConfig: any = null;

if (typeof window !== 'undefined') {
  try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);

    // Connecter à l'émulateur en développement
    if (process.env.NODE_ENV === 'development') {
      connectAuthEmulator(auth, 'http://localhost:9099');
    }

    remoteConfig = getRemoteConfig(app);
  } catch (error) {
    console.error('❌ Error initializing Firebase:', error);
  }
}

export { app, auth, remoteConfig };

export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();
export const appleProvider = new OAuthProvider('apple.com');

// Remote Config sera initialisé dynamiquement dans le provider pour éviter les erreurs SSR

export default app;
